import React, { useState, useEffect } from 'react';
import { api } from '../lib/apiClient';
import { TrendingUp, TrendingDown, Activity } from 'lucide-react';

// Placeholder freight market ticker. Wire to a real rate API later (DAT/Truckstop).
const FALLBACK = [
  { lane: 'Miami → Atlanta', rate: 2.41, change: 3.2 },
  { lane: 'Orlando → Charlotte', rate: 2.18, change: -1.1 },
  { lane: 'Tampa → Dallas', rate: 1.96, change: 2.4 },
  { lane: 'Jacksonville → Nashville', rate: 2.33, change: 1.8 },
  { lane: 'FL → Northeast', rate: 2.55, change: 4.1 },
  { lane: 'Reefer: FL Produce → Midwest', rate: 3.12, change: 5.6 },
  { lane: 'Flatbed: FL → TX', rate: 2.74, change: -0.8 },
  { lane: 'Broward → Carolinas', rate: 2.27, change: 2.0 },
];

const FreightTicker = () => {
  const [lanes, setLanes] = useState(FALLBACK);

  useEffect(() => {
    api.get('/freight/market').then((r) => {
      if (Array.isArray(r.data) && r.data.length) setLanes(r.data);
    }).catch(() => {});
  }, []);

  const items = [...lanes, ...lanes];

  return (
    <div className="bg-gray-900 border-y border-gray-800 overflow-hidden" data-testid="freight-ticker">
      <div className="flex items-center">
        <div className="flex items-center gap-2 bg-orange-600 text-white px-4 py-2.5 font-bold text-xs uppercase tracking-wider flex-shrink-0 z-10">
          <Activity className="h-4 w-4" />
          Freight Market
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex gap-8 whitespace-nowrap animate-marquee py-2.5">
            {items.map((l, i) => (
              <span key={i} className="inline-flex items-center gap-2 text-sm text-gray-300">
                <span className="font-medium text-white">{l.lane}</span>
                <span className="text-orange-400 font-semibold">${l.rate.toFixed(2)}/mi</span>
                <span className={`inline-flex items-center gap-0.5 text-xs ${l.change >= 0 ? 'text-green-400' : 'text-red-400'}`}>
                  {l.change >= 0 ? <TrendingUp className="h-3 w-3" /> : <TrendingDown className="h-3 w-3" />}
                  {Math.abs(l.change)}%
                </span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FreightTicker;
export { FreightTicker };
